export default __webpack_public_path__ + "static/media/Gail_Davis-Carter_AHV_In_Moms_We_Trust.b4da288e.jpg";